import { render, staticRenderFns } from "./SdsTableSection1Importer.vue?vue&type=template&id=8d449cb0"
import script from "./SdsTableSection1Importer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection1Importer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports